<i18n src="@/locales/modules/RequestTranslate.json"></i18n>

<template>
	<el-dialog
		class="custom-confirm-dialog"
		destroy-on-close
		:show-close="false"
		:close-on-click-modal="false"
		:visible.sync="isDialogActiveLocal"
		:title="$t('CancelRequestConfirm')"
	>
		<div>
			<label>{{ $t("InputCancelReason") }} <span class="text-danger">*</span>:</label>
			<cbs-textarea class="mt-2" type="textarea" name="cancel-reason" v-model="value.reason" v-validate="'required'" :rows="3" :data-vv-as="$t('Reason')" />
			<span class="text-danger text-sm" v-show="errors.has('cancel-reason')">{{ errors.first("cancel-reason") }}</span>
		</div>

		<div class="flex justify-end -mx-6" slot="footer">
			<vs-button class="w-1/3 font-bold text-solid-primary mr-3" type="flat" @click.stop="handleClickCancel">{{ $t("Actions.Cancel") }}</vs-button>
			<vs-button class="w-1/3 font-bold" @click.stop="handleClickConfirm">{{ $t("Actions.Confirm") }}</vs-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: "RequestCancelConfirmDialog",
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop =>
				prop.hasOwnProperty("id") &&
				prop.hasOwnProperty("reason")
		},
		isDialogActive: {
			type: Boolean,
			required: true
		}
	},
	emits: {
        onClickCancel: {},
        onClickConfirm: {}
    },
	computed: {
		isDialogActiveLocal: {
			get() {
				return this.isDialogActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeDialog");
				}
			}
		}
	},
	methods: {
		handleClickCancel() {
			this.$emit("onClickCancel");
		},
		handleClickConfirm() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.$emit("onClickConfirm", this.value);
				}
			});
		}
	}
}
</script>

<style>

</style>
